export const CHAT_MESSAGE_THREAD_ID = 'chatMessageThread';
export const DISTANCE_TO_BOTTOM_FOR_LOCK = 50;
export const DISTANCE_TO_TOP_TO_LOAD_MORE = 10;
